enum ActionTypes {
  APPEND_VALUES_TO_QUERY_STRING = 'APPEND_VALUES_TO_QUERY_STRING',
  STORE_SEARCH = 'STORE_SEARCH'
}

export default ActionTypes;
